import { Button, Box } from "@mui/material";
import { useContext } from "react";
import { FormContext, Form } from "components/shared/Form";
import DictionaryField from "components/ui/atoms/formFields/DictionaryField";
import { Stack } from "@mui/system";

const sorts = [
  { label: "Newer added", value: "-created_at" },
  { label: "Older added", value: "created_at" },
  { label: "Newer updated", value: "-updated_at" },
  { label: "Older updated", value: "updated_at" },
];

const prepareInitialValues = (object) => ({
  ordering: object?.ordering || "",
});

const SourcingSortFormFields = () => {
  const { onSubmit } = useContext(FormContext);

  return (
    <Stack spacing={2} width="100%">
      <DictionaryField
        optionsDictionary={Object.fromEntries(
          sorts.map((x) => [x.value, x.label]),
        )}
        name="ordering"
        label="Order by"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onSubmit}>
          Apply
        </Button>
      </Box>
    </Stack>
  );
};

const SourcingSortForm = (props) => {
  return (
    <Form prepareInitialValues={prepareInitialValues} {...props}>
      <SourcingSortFormFields />
    </Form>
  );
};

export default SourcingSortForm;
